/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreatePortalSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreatePortalSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreatePortalSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreatePortalSessionSecurity$outboundSchema: z.ZodMiniType<
  CreatePortalSessionSecurity$Outbound,
  CreatePortalSessionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createPortalSessionSecurityToJSON(
  createPortalSessionSecurity: CreatePortalSessionSecurity,
): string {
  return JSON.stringify(
    CreatePortalSessionSecurity$outboundSchema.parse(
      createPortalSessionSecurity,
    ),
  );
}

/** @internal */
export type CreatePortalSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreatePortalSessionRequest$outboundSchema: z.ZodMiniType<
  CreatePortalSessionRequest$Outbound,
  CreatePortalSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createPortalSessionRequestToJSON(
  createPortalSessionRequest: CreatePortalSessionRequest,
): string {
  return JSON.stringify(
    CreatePortalSessionRequest$outboundSchema.parse(createPortalSessionRequest),
  );
}
